<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Button from "../Button.svelte";
  import { navigateToPath } from "../../lib/routing";

  export let currentRoute;

  const goHome = () => navigateToPath("/");

  $: copy = $getCopy("404") as Record<string, string>;
</script>

<BaseStep {currentRoute} showBackButton={false}>
  <svelte:fragment slot="content">
    <div class="fourzerofour">
      <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
      <Button class="w-full mt-12 lg:w-48" primary on:click={goHome}>
        {copy.buttonCopy}
      </Button>
    </div>
  </svelte:fragment>
</BaseStep>
